<div class="tarjeta-accion"
     [class.tarjeta-accion--activa]="estado === 'activa'"
     [class.tarjeta-accion--configurada]="configurada || estado === 'configurada'"
     (click)="onTarjetaClick($event)">
  <div class="tarjeta-accion__body">
    <svg class="tarjeta-accion__icon">
      <use [attr.xlink:href]="icono"></use>
    </svg>
    <div class="tarjeta-accion__texto">
      <span class="tarjeta-accion__etiqueta">{{ etiqueta }}</span>
      <span class="tarjeta-accion__resumen" *ngIf="resumen">{{ resumen }}</span>
    </div>
  </div>
  <div class="tarjeta-accion__controles">
    <button type="button"
            class="tarjeta-accion__config"
            *ngIf="mostrarConfig"
            (click)="onConfigClick($event)"
            aria-label="Configurar">
      <svg class="icon-config">
        <use xlink:href="#hs-settings"></use>
      </svg>
    </button>
    <button type="button"
            class="tarjeta-accion__drag"
            *ngIf="mostrarDrag"
            [class.tarjeta-accion__drag--disabled]="!dragHabilitado"
            (click)="onDragClick($event)"
            aria-label="Colocar en documento">
      <svg class="icon-drag">
        <use xlink:href="#icon-draggable"></use>
      </svg>
    </button>
  </div>
</div>
